import doRequest from '@/api/dssRequest';
import { translate } from '@/translation/native_translate';
import store from '../store';
export default class UserParentChildRelations {
  requestNewChildRelation(data) {
    let objectId = store.getters['auth/userName'];
    let requestId = 'requestNewChildRelation';
    const payload = {
      Email: data.Email,
      Url: store.getters.getPartnerGroupUrl,
    };
    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          resolve(response);
          window.EventBus.fire('activateSnackBar', {
            text: translate('SENT_NEW_CHILD_RELATION_REQUEST'),
            color: 'success',
          });
        },
        (error) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('REQUEST_NEW_CHILD_RELATION_ERROR'),
            color: 'error',
          });
          reject(error);
        },
        requestId,
        objectId,
        payload
      );
    });
  }
  confirmUserRelationAsChild(route) {
    let objectId = route.query.ChildUserId;
    let requestId = 'confirmUserUserRelationAsChild';
    const payload = {
      ParentUserId: route.query.ParentUserId,
      Type: route.query.Type,
    };
    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          resolve(response);
          window.EventBus.fire('activateSnackBar', {
            text: translate('CONFIRM_NEW_CHILD_RELATION_SUCCESS'),
            color: 'success',
          });
        },
        (error) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('CONFIRM_NEW_CHILD_RELATION_ERROR'),
            color: 'error',
          });
          reject(error);
        },
        requestId,
        objectId,
        payload
      );
    });
  }

  removeUserUserRelation(data) {
    let objectId = store.getters['auth/userName'];
    let requestId = 'removeUserUserRelation';
    const payload = {
      ChildUserId: data.ChildUserId,
      Type: data.Type,
    };
    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          resolve(response);
          window.EventBus.fire('activateSnackBar', {
            text: translate('DELETE_CHILD_RELATION_SUCCESS'),
            color: 'success',
          });
        },
        (error) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('DELETE_CHILD_RELATION_ERROR'),
            color: 'error',
          });
          reject(error);
        },
        requestId,
        objectId,
        payload
      );
    });
  }
}
